import { useEffect } from 'react';
import { ChannelType } from '@/models/channel.model';
import { useAppDispatch, useAppState } from '@/store';
import {
  getBaseTemplateByType,
  selectLLMTemplateDetails,
  selectLLMTemplateDetailsError,
  selectLLMTemplateDetailsIsLoading,
} from '../feature';

export const useGetBaseTemplateByType = ({ channelType }: { channelType?: ChannelType }) => {
  const isLoading = useAppState(selectLLMTemplateDetailsIsLoading);
  const template = useAppState(selectLLMTemplateDetails);
  const error = useAppState(selectLLMTemplateDetailsError);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!channelType) return;
    dispatch(getBaseTemplateByType({ channelType }));
  }, [channelType, dispatch]);

  return {
    isLoading,
    template,
    error,
  };
};
